import { createSlice } from '@reduxjs/toolkit';
import { BaseApiState } from '../../api/axiosConfig';
import { loginResponse } from 'api/adminApi';
import { handlePending } from 'utils/redux';
import {
  fetchAdminLogin,
  fetchChangePassword,
  fetchResetPassword,
  fetchResetPasswordConfirm,
} from './thunks';

interface AdminState extends BaseApiState {
  loginData?: loginResponse;
  isRejected: boolean;
  changePasswordSuccessed: boolean;
  resetPasswordSuccessed: boolean;
  resetPasswordConfirmSuccessed: boolean;
}
const initialState: AdminState = {
  loginData: undefined,
  isRejected: false,
  succeeded: false,
  changePasswordSuccessed: false,
  resetPasswordSuccessed: false,
  resetPasswordConfirmSuccessed: false,
  loading: false,
  error: false,
  errorMessage: '',
  errorDetails: {},
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    resetLoginData(state) {
      state.loginData = undefined;
    },
    changePasswordSucceeded(state) {
      state.changePasswordSuccessed = false;
    },
    resetPasswordSucceeded(state) {
      state.resetPasswordSuccessed = false;
    },
    resetPasswordConfirmSucceeded(state) {
      state.resetPasswordConfirmSuccessed = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminLogin.pending, handlePending)
      .addCase(fetchAdminLogin.fulfilled, (state, action) => {
        state.loginData = action.payload;
        state.succeeded = true;
        state.loading = false;
        state.isRejected = false;
      })
      .addCase(fetchAdminLogin.rejected, (state) => {
        state.loginData = undefined;
        state.loading = false;
        state.isRejected = true;
      })
      .addCase(fetchChangePassword.pending, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchChangePassword.fulfilled, (state) => {
        state.errorMessage = '';
        state.changePasswordSuccessed = true;
      })
      .addCase(fetchChangePassword.rejected, (state, action) => {
        state.errorMessage = action.payload?.detail;
        state.changePasswordSuccessed = false;
      })
      .addCase(fetchResetPassword.pending, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchResetPassword.fulfilled, (state) => {
        state.errorMessage = '';
        state.resetPasswordSuccessed = true;
      })
      .addCase(fetchResetPassword.rejected, (state, action) => {
        state.errorMessage = action.payload?.detail;
        state.resetPasswordSuccessed = false;
      })
      .addCase(fetchResetPasswordConfirm.pending, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchResetPasswordConfirm.fulfilled, (state) => {
        state.errorMessage = '';
        state.resetPasswordConfirmSuccessed = true;
      })
      .addCase(fetchResetPasswordConfirm.rejected, (state, action) => {
        state.errorMessage = action.payload?.detail;
        state.resetPasswordConfirmSuccessed = false;
      });
  },
});

export const adminReducer = adminSlice.reducer;
export const {
  resetLoginData,
  changePasswordSucceeded,
  resetPasswordSucceeded,
  resetPasswordConfirmSucceeded,
} = adminSlice.actions;
